import styles from "./Card.module.scss";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
const Card = ({ item }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <motion.div
      className={styles.card}
      onHoverStart={() => setShowOverlay(true)}
      onHoverEnd={() => setShowOverlay(false)}
    >
      <AnimatePresence>
        {showOverlay && (
          <motion.a
            className={styles.overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            href={item.link}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
          </motion.a>
        )}
      </AnimatePresence>

      <img src={item.img} alt={item.id} />
    </motion.div>
  );
};

export default Card;
